import React from "react";
import "./Beaches.css";

import { useNavigate } from "react-router-dom";
import { Button } from "../../Components/Button/Button";
import Carrizalillo from "../../images/carrizalillo.jpg";
import LaPunta from "../../images/la_punta.jpg";
import Zicatela from "../../images/zicatela.jpg";

const cards = [
  {
    title: "Carrizalillo",
    description:
      "Empieza tu aventura en Carrizalillo, una encantadora bahía de aguas cristalinas y olas suaves, perfecta para principiantes que quieren aprender con seguridad y confianza.",
    image: Carrizalillo,
  },
  {
    title: "La Punta",
    description:
      "Si buscas algo más desafiante, dirígete a La Punta de Zicatela, el lugar ideal para surfistas intermedios que desean perfeccionar su técnica mientras disfrutan de un entorno vibrante y relajado.",
    image: LaPunta,
  },
  {
    title: "Zicatela",
    description: `¿Eres un amante de la adrenalina? Enfréntate a las legendarias olas de Zicatela, apodada el "Pipeline Mexicano", famosa a nivel mundial por su magnitud, perfección y las competencias internacionales que atraen a los mejores surfistas del planeta.`,
    image: Zicatela,
  },
];

export const Beaches = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/activities");
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-header">
        <h1>Playas</h1>
        <p>
          Puerto Escondido te espera con lecciones adaptadas a tu nivel,
          instructores experimentados y el ambiente perfecto para conectarte con
          el mar y disfrutar de una experiencia inolvidable. ¡Reserva tu clase
          de surf y conquista las olas!
        </p>
      </div>
      <div className="onboarding-cards-container">
        {cards.map((card, index) => (
          <div key={index} className="onboarding-card">
            <div className="onboarding-card-content">
              <h2 className="onboarding-title">{card.title}</h2>
              <p className="onboarding-description">{card.description}</p>
            </div>
            <img
              src={card.image}
              alt={card.title}
              className="onboarding-image"
            />
          </div>
        ))}
      </div>
      <Button type="primary" text="Reserva tu clase" onClick={handleRedirect} />
    </div>
  );
};
